import { Enums } from '../common/enums'

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'

import { OpDescr } from './op-descr'
import { DataProvider, TypeHelper } from '../../helpers'
import { Utils } from '../util/utils'

export class OpPackageStatus implements IReferenceType, IOpChangeState, IJsonSerializable {

    //#region Properties

    public idPackageStatus: number
    public packageStatus: string
    public idDescr: number

    //#endregion


    //#region NavigationProperties

    private _Descr: OpDescr

    public get descr(): OpDescr {
        return this._Descr
    }

    public set descr(value: OpDescr) {
        this._Descr = value
        this.idDescr = (value == null) ? null : value.idDescr
    }

    //#endregion


    //#region CustomProperties

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion


    //#region IOpChangeState Implementation

    public opState: Enums.OpChangeState

    //#endregion


    //#region IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdPackageStatus
    }

    public getReferenceKey(): number {
        return this.idPackageStatus
    }

    public getReferenceValue(): any {
        return this

    }

    //#endregion


    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {

            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                this.idDescr = opObj.ID
                this.idPackageStatus = opObj.I
                this.opState = opObj.O
                this.packageStatus = opObj.PS
                this.descr = opObj.DE != null ? new OpDescr(opObj.DE) : null
            }
            else {
                this.idDescr = opObj.ID_DESCR
                this.idPackageStatus = opObj.ID_PACKAGE_STATUS
                this.opState = opObj.OpState
                this.packageStatus = opObj.PACKAGE_STATUS
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
            }
        }

    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                ID: this.idDescr,
                I: this.idPackageStatus,
                O: this.opState,
                PS: this.packageStatus,
                DE: this.descr != null ? this.descr.toJSON(compressed) : null
            }

            TypeHelper.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        }

        return {
            ID_DESCR: this.idDescr,
            ID_PACKAGE_STATUS: this.idPackageStatus,
            OpState: this.opState,
            PACKAGE_STATUS: this.packageStatus,
            _Descr: this.descr != null ? this.descr.toJSON(compressed) : null,
        }
    }

    public toString(): string {
        if (this.descr != null) {
            return this.descr.description
        }

        return this.packageStatus
    }

    //#endregion   



    // public copy(toCopy: OpOperator) {
    //     if (toCopy) {
    //         if (toCopy.activities) {
    //             this.activities = toCopy.activities.map(a => new OpActivity(a))
    //         }
    //         if (toCopy.roles) {
    //             this.roles = toCopy.roles.map(r => new OpRole(r))
    //         }

    //         this.login = toCopy.login
    //         this.idOperator = toCopy.idOperator
    //         this.idDistributor = toCopy.idDistributor
    //         if (toCopy.actor) {
    //             this.actor = new OpActor(toCopy.actor)
    //         }
    //         if (toCopy.area) {
    //             this.area = new OpPolygon(toCopy.area)
    //         }
    //         if (toCopy.profile) {
    //             this.profile = new OpProfile(toCopy.profile)
    //         }
    //     }
    // }


    //#region loadNavigationProperties

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpPackageStatus[]): JQueryPromise<OpPackageStatus[]> {

        const deferred: JQueryDeferred<OpPackageStatus[]> = $.Deferred<OpPackageStatus[]>()

        deferred.resolve(list)

        return deferred.promise()
    }

    //#endregion


    //     //#region fromIOpObject

    //     public static fromIOpObject(object: IOpObject): OpOperator {
    //         const newObject: OpOperator = new OpOperator(null)

    //         newObject.idOperator = object.idObject
    //         newObject.opState = object.opState
    //         newObject.dataList.push(...object.dataList.toArray().map((data: IOpData) => OpOperatorData.fromIOpData(data)))

    //         return newObject
    //     }

    //     //#endregion
}